import React from "react";

/**
 * Detect credit variant from image URL.
 * AI patterns: /gen-* generated with Nano Banana for this site.
 */
export const detectCreditVariant = (src = "", override) => {
  if (override === "ai" || override === "veca") return override;
  if (/\/images\/gen-/i.test(src)) return "ai";
  return "veca";
};

/**
 * ImageCredit — overlay discreto para créditos de imagen.
 * Props:
 *   - variant: "ai" | "veca"  (si no se pasa, se intenta inferir de `src`)
 *   - src: path de la imagen (opcional, usado para inferir variant)
 *   - size: "sm" | "md" | "lg"
 *     - "sm" se usa en recuadros pequeños y NO se muestra crédito (regla del usuario)
 *   - linkVeca: si true, el crédito "Alessandro Veca" se vuelve enlace a su web oficial
 *
 * Diseño: esquina inferior derecha, pequeño, semi-transparente (estilo editorial).
 */
const VECA_URL = "https://www.alessandrovecaphotographer.net/";

const ImageCredit = ({ variant, src = "", size = "md", linkVeca = false, className = "" }) => {
  if (size === "sm") return null; // nunca mostrar en frames muy pequeños

  const v = detectCreditVariant(src, variant);
  const label = v === "ai" ? "Imagen generada con IA" : "Alessandro Veca";
  const base =
    "absolute z-20 select-none tracking-[0.12em] uppercase text-pietra-light/70 bg-grafite/30 backdrop-blur-[2px] rounded-sm";

  const sizeMap = {
    md: "bottom-2 right-2 text-[0.55rem] px-1.5 py-[2px]",
    lg: "bottom-3 right-4 text-[0.65rem] px-2 py-[3px] tracking-[0.15em]",
  };

  const combined = `${base} ${sizeMap[size] || sizeMap.md} ${className}`;

  // Veca credit as a link to his photographer site
  if (v === "veca" && linkVeca) {
    return (
      <a
        href={VECA_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="image-credit-veca-link"
        className={`${combined} hover:text-miele hover:bg-grafite/50 transition-colors`}
      >
        {label} ↗
      </a>
    );
  }

  return (
    <span
      data-testid={`image-credit-${v}`}
      className={`${combined} pointer-events-none`}
    >
      {label}
    </span>
  );
};

export default ImageCredit;
